import React, { useState } from 'react';
import GlobalDialog from '../../../../components/mui/Dialogue/GlobalDialog';
import { AddButton, CancelButton, SaveButton } from '../../../../components/mui/Buttons/Buttons';
import { Form, FormikProvider, useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { createHrpolicyType, getRootPolicy } from '../../../../redux/features/hrPolicySlice';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const CreateHrPolicyType = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  const { rootPolicies, loading } = useSelector((state) => state.hrPolicy);

  const Schema = Yup.object().shape({
    rootTypeId: Yup.string().required('rootTypeId is required'),
    policyTypeName: Yup.string().required('policyTypeName is required'),
  });

  const formik = useFormik({
    initialValues: {
      rootTypeId: '',
      policyTypeName: '',
    },
    validationSchema: Schema,
    onSubmit: (values, { resetForm }) => {
      dispatch(createHrpolicyType(values)).then((res) => {
        handleApiResponse(res, {
          onSuccess: () => {
            setOpen(false);
            resetForm();
          },
          onFailed: () => {
            console.log('Something went wrong');
          },
        });
      });
    },
  });
  return (
    <GlobalDialog
      title={'Create Hr Policy Type'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      fullWidth
      maxWidth={'sm'}
      popupButton={
        <AddButton size={'small'} action={() => setOpen(true)}>
          Create Hr policy Type
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Stack direction={'column'} spacing={2}>
                <FormControl
                  fullWidth
                  error={formik.touched.courseAvailableName && Boolean(formik.errors.courseAvailableName)}
                >
                  <InputLabel id="root-select-label">Root Policy Type</InputLabel>
                  <Select
                    labelId="root-select-label"
                    name="rootTypeId"
                    label="Root Policy Type"
                    value={formik.values.rootTypeId}
                    onChange={(e) => {
                      const value = e.target.value;

                      formik.setFieldValue('rootTypeId', value);
                    }}
                  >
                    {rootPolicies.map((item) => (
                      <MenuItem key={item.root_policy_type_id} value={item.root_policy_type_id}>
                        {item.root_policy_type_name}
                      </MenuItem>
                    ))}
                  </Select>
                  {formik.touched.rootTypeId && formik.errors.rootTypeId && (
                    <FormHelperText>{formik.errors.rootTypeId}</FormHelperText>
                  )}
                </FormControl>
                <TextField
                  label="Type Name"
                  name="policyTypeName"
                  value={formik.values.policyTypeName}
                  onChange={formik.handleChange}
                  error={formik.touched.policyTypeName && Boolean(formik.errors.policyTypeName)}
                  helperText={formik.errors.policyTypeName}
                />
              </Stack>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                <Stack direction={'row'} spacing={1}>
                  <CancelButton size={'small'} action={() => setOpen(false)}>
                    Cancel
                  </CancelButton>
                  <SaveButton size={'small'} type={'submit'}>
                    {loading ? 'please wait...' : 'Save'}
                  </SaveButton>
                </Stack>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default CreateHrPolicyType;
